module.exports = __webpack_public_path__ + "img/flower.6fefbb53.png";